import React from "react";
import { HStack, VStack, SimpleGrid, Text, Spacer, Button, Divider, Wrap, WrapItem } from "@chakra-ui/react";
import { format } from "date-fns";
import { useHistory } from "react-router-dom";

import { useUser } from "context/user";
import { isActiveSession, isCancelledSession } from "utils/session";
import { GetCommaSeperatedClientList } from "utils/user";
import { Callback, Session } from "types";
import { Card } from "components";
import AppointmentOptionsButton from "./AppointmentOptionsButton";
import { LineIcon } from "components/Icons";

interface Props {
  session: Session;
}

const AppointmentRow: React.FC<Props> = ({ session }: Props) => {
  const { title, coach, participants, start_time, end_time } = session;
  const history = useHistory();

  return (
    <Card bgColor={isActiveSession(session) ? "blue.400" : "gray.800"}>
      <SimpleGrid gap={4} columns={2} templateColumns="5fr fit-content(100%)" color={isActiveSession(session) ? "blue.800" : "white"}>
        <HStack alignItems="center">
          <Text fontSize="2xl" fontWeight="bold" width="45%">
            {title}
          </Text>
          <Spacer />
          <Divider
            orientation="vertical"
            borderColor={isActiveSession(session) ? "blue.800" : "white"}
          />
          <VStack alignItems="left">
            <Text
              fontSize="lg"
              fontWeight="thin"
            >
              {GetCommaSeperatedClientList(participants, coach)}
            </Text>
            <Text fontWeight="light" justifySelf="flex-end">
              {`${format(new Date(start_time), "PP")} `}
              <LineIcon color={isActiveSession(session) ? "gray.800" : "blue.500"} />
              {` ${format(new Date(start_time), "p")} - ${format(new Date(end_time), "p")}`}
            </Text>
          </VStack>
          <Divider
            orientation="vertical"
            borderColor={isActiveSession(session) ? "blue.800" : "white"}
          />
          <Text fontWeight="light" justifySelf="flex-end">
            {coach && `Coach ${coach.first_name} ${coach.last_name}`}
          </Text>
        </HStack>
        <HStack alignItems="left">
          <Spacer />
          <Spacer />
          <Button
            aria-label="Start Session"
            hidden={!isActiveSession(session) || isCancelledSession(session)}
            onClick={() => history.push(`/session/${session.id}/preview`)}
            size="xs"
            variant="blue"
          >
            Join
          </Button>
          <AppointmentOptionsButton session={session} />
        </HStack>
      </SimpleGrid>
    </Card>
  );
};

export default AppointmentRow;
